export function hideImage({ target }) {
    target.style.display = "none"
}

export function showImage({ target }) {
    target.style.display = null
}
